import { ObservableArray, View } from "binder"
import { SendPackageProduct, SendPackageProductsViewModel } from "./sendPackageProducts-viewModel"

export class SendPackageProductsView extends View<SendPackageProductsViewModel>{
    GetViewUniqueId(): string {
        return "V-B43C5BE2-FF36-4E98-8593-C33EED61D7BF"
    }
    loadHtml(): string {
        let element = require('./sendPackageProducts.html').default;
        let style = require('./sendPackageProducts.less');
        return element;
    }
    constructor() {
       super();
    }
    public set tabName(v: string) { this._tabName = v; } public get tabName(): string { return this._tabName;} private _tabName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set sendPackageProducts(v: ObservableArray<SendPackageProduct>) { this._sendPackageProducts = v; } public get sendPackageProducts(): ObservableArray<SendPackageProduct> { return this._sendPackageProducts; } private _sendPackageProducts: ObservableArray<SendPackageProduct>;

}
